/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    "./src/pages/**/*.{js,jsx,ts,tsx}",
    "./src/components/**/*.{js,jsx,ts,tsx}",
  ],
  safelist: [
    {
      pattern: /bg-.*/,
    },
    {
      pattern: /text-.*/,
      variants: ['hover', 'focus', 'active', 'placeholder', 'option'],
    },
    {
      pattern: /gradient-.*/,
    },
    {
      pattern: /font-.*/,
      variants: ['placeholder', 'option'],
    },
	  {
		pattern: /border-.*/,
		},
		{
		pattern: /w-.*/,
	  },
		{
			pattern: /max-w-.*/,
		},
		// Add specific patterns for arbitrary value classes used in Container.js
		// Paddings with arbitrary values
		{
			pattern: /pt-.*/,
		},
		{
			pattern: /pb-.*/,
		},
		// Margins with arbitrary values
		{
			pattern: /mt-.*/,
		},
		{
			pattern: /mb-.*/,
		},
		// Background colors with arbitrary values
		{
			pattern: /bg-.*/,
		},
    {
        pattern: /^pl-.*/,
        variants: ['group-hover'],
    },
    {
      pattern: /^(ring|outline|border|bg|shadow|resize|bg)-./,
      variants: ['focus', 'hover', 'active', 'disabled', 'checked', 'checked:focus', 'checked:hover'],
    },
    {
      pattern: /^gap-.*/,
      variants: ['hover'],
    },
    {
      pattern: /rounded-.*/
    },

    // Form Styling
    'bg-[position:95%_center]',
    'rounded-[4px]',
    'checked:bg-center',
    'checked:bg-[size:auto]',
    'form-fields-gradient',
	'background-image',
    'hover:form-fields-gradient-hover',
    'h-[200px]',
    'pt-12',
    '-mt-[30px]',
    'z-20',
	'z-[21]',
    'z-30',
	'z-100',
    'pl-8',
    'pb-6',
    'rounded-bottom_32',
    'transition-all duration-500 ease-in-out',
    'block visible opacity-100',
    'hidden invisible opacity-0',
    'h-1',
    'hover:font-bold',
    'focus:font-bold',
    'checked:after:absolute',
    'checked:after:content-[""]',
    'checked:after:block',
    'checked:after:h-[8px]',
    'checked:after:w-[8px]',
    'checked:after:bg-orange',
    'checked:after:rounded-[2px]',
    'checked:after:top-1/2',
    'checked:after:left-1/2',
    'checked:after:-translate-x-1/2',
    'checked:after:-translate-y-1/2',
	'my-[48px]',
	'w-[80px]',

  ],
  theme: {
    colors: {
		dark_green: "#165F57",
		soft_blue: "#D3E5EA",
		soft_green: "#E1E9DD",
		separator: "#6494A1",
		green: "#7AC593",
		orange: "#F49F65",
		light_grey: "#F4F3F3",
			light_green: "#A2D6B3",
		offwhite: "#FAFAFA",
		transparent: "transparent",
		white: "#FFF",
		black: "#000",
		red_error: "#B00E08",
		granite: "#13131E",
		"white-85": "rgb(255 255 255 / 0.85)",
		btn_separator: "rgba(244, 159, 101, 0.7)",
		light_orange: "rgba(244, 159, 101, 0.3)",
		soft_blue_2: "rgba(211, 229, 234, 0.7)",
		text_paragraph: "rgba(0, 0, 0, 0.70)",
        error: "#D80000",
		card_header_orange: "rgba(244, 159, 101, 0.3)",
		},
		width: {
			default: '1204px',
			default_plus: '1296px',
			full: '100%',
			max_content: 'max-content',
			md: '768px',
			lg: '1024px',
		},
		maxWidth: {
			default: '1204px',
			default_plus: '1296px',
			full: '100%',
			max_content: 'max-content',
			md: '768px',
			lg: '1024px',
		},
		screens: {
			mobile: "375px",
			md: "768px",
			lg: "1024px",
			mobileMax: { max: "767px" },
			mobileTabletMax: { max: "1023px" },
			xl: "1280px",
			laptop: "1440px",
			default: "1204px",
		},
		extend: {
			textShadow: {
				sm: '0 1px 2px rgba(0, 0, 0, 0.2)',
				DEFAULT: '0 2px 4px rgba(0, 0, 0, 0.3)',
				lg: '0 8px 16px rgba(0, 0, 0, 0.5)',
				xl: '0px 0px 36px rgba(0, 0, 0, 0.7)',
			},
			backgroundImage: {
				"gradient-soft-blue": "linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)),linear-gradient(0deg, rgba(211, 229, 234, 0.7), rgba(211, 229, 234, 0.7));",
				"gradient-soft-green": "linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)),linear-gradient(0deg, rgba(225, 233, 221, 0.7), rgba(225, 233, 221, 0.7));",
				"gradient-green-light": "linear-gradient(0deg, rgba(122, 197, 147, 0.7), rgba(122, 197, 147, 0.7));",
				"gradient-card-border": "linear-gradient(103.36deg, #FFFFFF 7.86%, rgba(92, 143, 137, 0.4) 12.11%, rgba(92, 143, 137, 0.4) 88.58%, #FFFFFF 92.83%)",
				"gradient-green": "linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), linear-gradient(0deg, rgba(122, 197, 147, 0.5), rgba(122, 197, 147, 0.5));",
				"gradient-blue": "linear-gradient(0deg, rgba(211, 229, 234, 0.7), rgba(211, 229, 234, 0.7));",
				"gradient-card-header": "linear-gradient(0deg, rgba(122, 197, 147, 0.70) 0%, rgba(122, 197, 147, 0.70) 100%);",
				"gradient-references": "linear-gradient(0deg, rgba(122, 197, 147, 0.30) 0%, rgba(122, 197, 147, 0.30) 100%)",
				"gradient-header": "linear-gradient(180deg, rgba(255, 255, 255, 0.70) 0 %, rgba(255, 255, 255, 0.00) 100 %)",
				// begin patient site styles
				"gradient-teal-box":
					"linear-gradient(278deg, #5CBFCF -30.74%, #E4F5F7 11.07%, #FFF 45.02%)",
				"gradient-teal-table":
					"linear-gradient(0deg, rgba(255, 255, 255, 0.50) 0%, rgba(255, 255, 255, 0.50) 100%), linear-gradient(256deg, #E6FBFF -20.03%, #5CBFCF 89.95%)",
				"gradient-tabs":
					"linear-gradient(278deg, #5CBFCF -30.74%, #E4F5F7 14.85%, #FFF 45.02%)",
				"gradient-blue-box":
					"linear-gradient(232deg, rgba(93, 115, 252, 0.14) -37.77%, rgba(188, 197, 254, 0.47) 1.11%, rgba(255, 255, 255, 0.70) 94.73%)",
				"gradient-main-nav": "linear-gradient(0deg, rgba(211, 229, 234, 0.30) 0%, rgba(211, 229, 234, 0.30) 100%), rgba(255, 255, 255, 0.40)",
				"header-gradient": "linear-gradient(180deg, rgba(255, 255, 255, 0.70) 0%, rgba(255, 255, 255, 0.00) 100%);",
				"header-white-gradient": "linear-gradient(180deg,rgba(255, 255, 255, 0.9) 27%, rgba(196, 177, 0, 0) 100%)",
				"header-dark-gradient": "linear-gradient(180deg,rgba(0, 0, 0, 0.36) 20%, rgba(0, 0, 0, 0) 100%)",
			},
			fontFamily: {
				asap_condensed: "asap-condensed",
				gt_walsheim: ["GT Walsheim", "sans-serif"],
				fields: "fields",
				gt_walsheim_regular: {
					fontFamily: "GT Walsheim",
					fontWeight: "400"
				},
				gt_walsheim_medium: {
					fontFamily: "GT Walsheim",
					fontWeight: "500"
				},
				gt_walsheim_bold: {
					fontFamily: "GT Walsheim",
					fontWeight: "700"
				},
				sink: {
					fontFamily: "Sink",
					fontWeight: "400"
				},
			},
			fontSize: {
				h1_4xl: ["7.5rem", { lineHeight: "7.5rem", fontWeight: "900" }], // 120px
				h1_3xl: ["6.5rem", { lineHeight: "6.5rem", fontWeight: "900" }], // 104px
				h1_2xl: ["5.973rem", { lineHeight: "5.375rem", fontWeight: "800" }], // 95.5px
				h1_40: ["2.5rem", { lineHeight: "2.5rem", fontWeight: "800" }], // 40px
				h1_64: ["4rem", { lineHeight: "4rem", fontWeight: "800" }], // 64px
				h1_72: ["4.5rem", { lineHeight: "4.5rem", fontWeight: "700" }], // 72px
				h1_48: ["3.5rem", { lineHeight: "3.5rem", fontWeight: "800" }], // 56px
				h1_xl: ["5rem", { lineHeight: "4.5rem", fontWeight: "800" }], // 80px
				h1_xl_mobile: ["3.5rem", { lineHeight: "3.5rem", fontWeight: "800" }], // 56px
				h1_lg: ["2.625rem", { lineHeight: "2.625rem", fontWeight: "700" }], // 42px
				h2: ["2.5rem", { lineHeight: "normal", fontFamily: "GT Walsheim", color: "theme(colors.dark_green)" }], // 40px
				h3: ["2rem", { lineHeight: "100%", fontFamily: "GT Walsheim", color: "theme(colors.dark_green)" }], // 32px
				h4: ["1.5rem", { lineHeight: "28px", fontFamily: "GT Walsheim", color: "theme(colors.dark_green)" }], // 24px
				h4_medium: ["1.5rem", { lineHeight: "28px", fontWeight: "500", fontFamily: "GT Walsheim", color: "theme(colors.dark_green)" }], // 24px
				h4_medium_mobile: ["1rem", { lineHeight: "20px", fontWeight: "500", fontFamily: "GT Walsheim", color: "theme(colors.dark_green)" }], // 16px
				h5: ["1.25rem", { lineHeight: "28px", fontFamily: "GT Walsheim", color: "theme(colors.dark_green)" }], // 20px
				h6: ["1rem", { lineHeight: "28px", fontFamily: "GT Walsheim", color: "theme(colors.dark_green)" }], // 16px
				p: ["1rem", { lineHeight: "normal", fontWeight: "400", fontFamily: "GT Walsheim", color: "theme(colors.paragraph)" }], // 16px
				p_mobile: ["0.875rem", { lineHeight: "normal", fontWeight: "400", fontFamily: "GT Walsheim", color: "theme(colors.paragraph)" }], // 16px
				p_medium: ["0.875rem", { lineHeight: "normal", fontWeight: "500", fontFamily: "GT Walsheim", color: "theme(colors.paragraph)" }], // 14px
				p_footnote: ["0.75rem", { lineHeight: "normal", fontWeight: "400", fontFamily: "GT Walsheim", color: "theme(colors.paragraph)" }], // 12px
				p_10: ["0.625rem", { lineHeight: "normal", fontWeight: "400", fontFamily: "GT Walsheim", color: "theme(colors.paragraph)" }], // 10px
        p_error: ["0.75rem", { lineHeight: "normal", fontWeight: "400", fontFamily: "GT Walsheim", color: "theme(colors.error)" }], // 12px
			},
			boxShadow: {
				"header-na": "0px 3px 7px 0px rgba(0, 0, 0, 0.16)",
				"access-point-na": "0px -4px 4px 0px rgba(0, 0, 0, 0.05)",
				nav: "0 4px 6px -1px rgba(0, 0, 0, 0.10), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)",
				isi: "0px 0px 10px 0px rgba(0, 0, 0, 0.10)",
				"nav-submenu": "0px 0px 50px 0px rgba(0, 0, 0, 0.05) inset, 0px 20px 50px -20px rgba(0, 0, 0, 0.10)",
            custom_select: "0px 0px 50px 0px #0000000D",
			},
			spacing: {
				'30': '1.875rem', // 30px
			},
			borderRadius: {
				all_48: "48px",
				all_32: "32px",
				top_48: '48px 48px 0 0',
				bottom_48: '0 0 48px 48px',
				all_100: "100px",
        bottom_32: '0 0 32px 32px',
			},
			border: {
				'custom': '1px solid #000',
			},
		},
	},
	plugins: [
		require("@tailwindcss/forms"),
		function ({ addUtilities, theme }) {
			const newUtilities = {};

			addUtilities(newUtilities);

			// Add text shadow utilities
			const textShadows = theme('textShadow', {});
			const textShadowUtilities = Object.entries(textShadows).reduce(
				(acc, [key, value]) => ({
					...acc,
					[`.text-shadow${key === 'DEFAULT' ? '' : `-${key}`}`]: {
						textShadow: value,
					},
				}),
				{}
			);
			addUtilities(textShadowUtilities);

			addUtilities({
				'.border-gradient-light': {
					'position': 'relative',
					'border-radius': '48px',
					'isolation': 'isolate',
					'&::before': {
						'content': '""',
						'position': 'absolute',
						'inset': '-1px',
						'border-radius': '48px',
						'padding': '1px',
						'background': 'linear-gradient(103deg, #FFF 7.86%, rgba(92, 143, 137, 0.40) 12.11%, rgba(92, 143, 137, 0.40) 88.58%, #FFF 92.83%)',
						'mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask-composite': 'xor',
						'mask-composite': 'exclude',
						'z-index': '-1'
					},
					'box-shadow': 'inset 0px 0px 50px 0px rgba(0, 0, 0, 0.05), 0px 20px 50px -20px rgba(0, 0, 0, 0.10)',
					'backdrop-filter': 'blur(50px)',
				},
				'.container-gradient-light': {
					'position': 'relative',
					'border-radius': '48px',
					'isolation': 'isolate',
					'&::before': {
						'content': '""',
						'position': 'absolute',
						'inset': '-1px',
						'border-radius': '48px',
						'padding': '1px',
						'background': 'linear-gradient(103deg, #FFF 7.86%, rgba(92, 143, 137, 0.40) 12.11%, rgba(92, 143, 137, 0.40) 88.58%, #FFF 92.83%)',
						'mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask-composite': 'xor',
						'mask-composite': 'exclude',
						'z-index': '-1'
					},
					'box-shadow': 'inset 0px 0px 50px 0px rgba(0, 0, 0, 0.05), 0px 20px 50px -20px rgba(0, 0, 0, 0.10)',
					'backdrop-filter': 'blur(50px)'
				},
				'.child-gradient-light > *': {
					'position': 'relative',
					'border-radius': '48px',
					'isolation': 'isolate',
					'&::before': {
						'content': '""',
						'position': 'absolute',
						'inset': '-1px',
						'border-radius': '48px',
						'padding': '1px',
						'background': 'linear-gradient(103deg, #FFF 7.86%, rgba(92, 143, 137, 0.40) 12.11%, rgba(92, 143, 137, 0.40) 88.58%, #FFF 92.83%)',
						'mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask-composite': 'xor',
						'mask-composite': 'exclude',
						'z-index': '-1'
					},
					'backdrop-filter': 'blur(50px)'
				},
				'.sectionNav-gradient-light': {
					'border-radius': '48px',
					'isolation': 'isolate',
					'&::before': {
						'content': '""',
						'position': 'absolute',
						'inset': '-1px',
						'border-radius': '48px',
						'padding': '1px',
						'background': 'linear-gradient(103deg, #FFF 1.86%, rgba(92, 143, 137, 0.40) 6.11%, rgba(92, 143, 137, 0.40) 96.58%, #FFF 97.83%)',
						'mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask-composite': 'xor',
						'mask-composite': 'exclude',
						'z-index': '-1'
					},
					'box-shadow': 'inset 0px 0px 50px 0px rgba(0, 0, 0, 0.05), 0px 20px 50px -20px rgba(0, 0, 0, 0.10)',
					'backdrop-filter': 'blur(50px)'
				},
				'.sectionNav-connect-gradient': {
					'border-radius': '0px 0px 32px 32px',
					'isolation': 'isolate',
					'&::before': {
						'content': '""',
						'position': 'absolute',
						'inset': '-1px',
						'border-radius': '0px 0px 32px 32px',
						'padding': '1px',
						'background': 'linear-gradient(103deg, #FFF 1.86%, rgba(92, 143, 137, 0.40) 6.11%, rgba(92, 143, 137, 0.40) 96.58%, #FFF 97.83%)',
						'mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask-composite': 'xor',
						'mask-composite': 'exclude',
						'z-index': '-1'
					},
					'box-shadow': 'inset 0px 0px 50px 0px rgba(0, 0, 0, 0.05), 0px 20px 50px -20px rgba(0, 0, 0, 0.10)',
					'backdrop-filter': 'blur(20px)'
				},
				'.border-table-light': {
					'position': 'relative',
					'border-radius': '32px',
					'isolation': 'isolate',
					'width': 'max-content',
					'&::before': {
						'content': '""',
						'position': 'absolute',
						'inset': '0px',
						'border-radius': '32px',
						'padding': '1px',
						'width': '100%',
						'height': '100%',
						'background': 'linear-gradient(112deg, #FFF 7%, rgba(92, 143, 137, 0.40) 10%, rgba(92, 143, 137, 0.40) 91%, #FFF 94%)',
						'mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask-composite': 'xor',
						'mask-composite': 'exclude',
						'z-index': '-1'
					},
					'box-shadow': 'inset 0px 0px 50px 0px rgba(0, 0, 0, 0.05), 0px 20px 50px -20px rgba(0, 0, 0, 0.10)',
					'backdrop-filter': 'blur(50px)'
				},
				'.border-gradient-light-small': {
					'position': 'relative',
					'border-radius': '48px',
					'isolation': 'isolate',
					'width': 'max-content',
					'&::before': {
						'content': '""',
						'position': 'absolute',
						'inset': '-1px',
						'border-radius': '48px',
						'padding': '1px',
						'background': 'linear-gradient(116deg, #FFF 7%, rgba(92, 143, 137, 0.40) 10%, rgba(92, 143, 137, 0.40) 91%, #FFF 94%)',
						'mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask-composite': 'xor',
						'mask-composite': 'exclude',
						'z-index': '-1'
					},
					'box-shadow': 'inset 0px 0px 50px 0px rgba(0, 0, 0, 0.05), 0px 20px 50px -20px rgba(0, 0, 0, 0.10)',
					'backdrop-filter': 'blur(50px)'
				},
				'.border-gradient-events': {
					'position': 'relative',
					'border-radius': '48px',
					'isolation': 'isolate',
					'&::before': {
						'content': '""',
						'position': 'absolute',
						'inset': '-1px',
						'border-radius': '48px',
						'padding': '1px',
						'background': 'linear-gradient(116deg, #FFF 7%, rgba(92, 143, 137, 0.40) 10%, rgba(92, 143, 137, 0.40) 91%, #FFF 94%)',
						'mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask-composite': 'xor',
						'mask-composite': 'exclude',
						'z-index': '-1'
					},
					'box-shadow': 'inset 0 0 50px 0 rgba(0, 0, 0, 0.05), 0px 20px 50px -20px rgba(0, 0, 0, 0.10)',
					'backdrop-filter': 'blur(100px)'
				},
				'.border-gradient-events-hover': {
					'&::before': {
						'background': 'linear-gradient(68deg, rgba(255, 255, 255, 0.70) 7%, rgba(22, 95, 87, 0.60) 10%, rgba(22, 95, 87, 0.60) 91%, rgba(255, 255, 255, 0.70) 94%)',
					},
				},
				'.border-gradient-button': {
					'position': 'relative',
					'border-radius': '48px',
					'isolation': 'isolate',
					'&::before': {
						'content': '""',
						'position': 'absolute',
						'inset': '-1px',
						'border-radius': '48px',
						'padding': '1px',
						'background': 'linear-gradient(116deg, #FFF 7%, rgba(92, 143, 137, 0.40) 10%, rgba(92, 143, 137, 0.40) 91%, #FFF 94%)',
						'mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask-composite': 'xor',
						'mask-composite': 'exclude',
						'z-index': '-1',
					},
					'box-shadow': '0px 0px 50px 0px rgba(0, 0, 0, 0.05) inset, 0px 20px 50px -20px rgba(0, 0, 0, 0.10)',
					'backdrop-filter': 'blur(50px)'
				},
				'.border-gradient-button-hover': {
					'&::before': {
						'background': 'linear-gradient(68deg, rgba(255, 255, 255, 0.70) 7%, rgba(92, 143, 137, 0.60) 10%, rgba(92, 143, 137, 0.60) 91%, rgba(255, 255, 255, 0.70) 94%)',
					  },
				},
				'.border-gradient-button-dark': {
					'position': 'relative',
					'border-radius': '48px',
					'isolation': 'isolate',
					'width': 'max-content',
					'&::before': {
						'content': '""',
						'position': 'absolute',
						'inset': '-1px',
						'border-radius': '48px',
						'padding': '1px',
						'background': 'linear-gradient(116deg, rgba(255, 255, 255, 0.70) 7%, rgba(92, 143, 137, 0.60) 10%, rgba(92, 143, 137, 0.60) 91%, rgba(255, 255, 255, 0.70) 94%)',
						'mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
						'-webkit-mask-composite': 'xor',
						'mask-composite': 'exclude',
						'z-index': '-1'
					},
					'box-shadow': '0px 0px 50px 0px rgba(0, 0, 0, 0.05) inset, 0px 20px 50px -20px rgba(0, 0, 0, 0.20)',
					'backdrop-filter': 'blur(50px)'
        },
        '.form-fields-gradient': {
          'position': 'relative',
          'border-radius': '48px',
          'isolation': 'isolate',
          '&::before': {
            'content': '""',
            'position': 'absolute',
            'inset': '-1px',
            'border-radius': '48px',
            'padding': '1px',
            'background': 'linear-gradient(150deg, rgba(255, 255, 255, 0.70) 6%, rgba(92, 143, 137, 0.60) 8%, rgba(92, 143, 137, 0.60) 91%, rgba(255, 255, 255, 0.70) 95%)',
            'mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            '-webkit-mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            '-webkit-mask-composite': 'xor',
            'mask-composite': 'exclude',
            'z-index': '-1'
          },
          'box-shadow': '0px 0px 50px 0px rgba(0, 0, 0, 0.05) inset, 0px 20px 50px -20px rgba(0, 0, 0, 0.10)',
          'backdrop-filter': 'blur(20px)',
          'background': 'rgba(255, 255, 255, 0.50)'
        },
        '.form-fields-gradient-hover': {
          '&::before': {
            'background': 'linear-gradient(68deg, rgba(255, 255, 255, 0.70) 7%, rgba(92, 143, 137, 0.60) 10%, rgba(92, 143, 137, 0.60) 91%, rgba(255, 255, 255, 0.70) 94%)',
          },
        },
      });
    },
  ],
};
